module.exports = __webpack_public_path__ + "static/thpcfarmmain-f3f1a1bda860948dbbd804705f2be283.jpeg";